module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><polygon points=\"12 9 7 15 17 15 12 9\"></polygon></svg>"